var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-6" },
    [
      _c(
        "div",
        { staticClass: "flex gap-2 text-primary" },
        [
          _c("v-icon", [_vm._v(" $statsHeader ")]),
          _c("span", { staticClass: "text-xl font-medium" }, [
            _vm._v("การวิเคราะห์"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "p-5 bg-white rounded-semi-md flex flex-col gap-7" },
        [
          _c("AnalyzeFacebookPixel"),
          _c("AnalyzeFacebookVerifyDomain"),
          _c("AnalyzeGoogleAnalysis"),
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "flex flex-col sm:flex-row gap-1 sm:gap-3" },
                [
                  _c("span", { staticClass: "text-h3-headline" }, [
                    _vm._v("Ad Event สำหรับ Facebook Page"),
                  ]),
                  _c("AdEventCreate"),
                  _c("v-spacer"),
                  _c("AdEventGuide"),
                ],
                1
              ),
              _c("AdEventTable"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }